import $session from 'servicestack/session'

function LogoutDirectiveFactory($parse, $window, $location) {
    return {
        scope: false,
        link(scope, element, attr) {
            var $targets = (attr.logout ? element.find(attr.logout) : element);
            $targets.on('click', function () {
                return $session.logout().then(res => {
                    $parse(attr.onLogout)(scope, res);
                    //$window.location.reload();
                    $window.location = "/";
                });
            });
        }
    }
}

export default LogoutDirectiveFactory;